<div>
  <mat-progress-spinner
    [color]="color"
    [mode]="mode"
    [value]="value"
    class="example-margin">
  </mat-progress-spinner>
</div>
